import { makePermissionMap } from '../utils/KitCommon';

export interface AppSession {
  prefLangLocale: string;
  isLoggedIn: boolean;
  dataServer: string;
  accountsAPI: string;
  l10nUnits: { length: string; volume: string };
  currencyCode: string;
  currencySymbol: string;
  companyID: number;
  permissions: Map<string, boolean>;
  supportEmail: string;
  customerSupportNumber: string;
  portalTimezone: string;
  subdomain: string;
  brandedLogoURL: string;
  userInfo: UserInfo;
  nosletMapCoordinates: { lat: number; lon: number };
  corporateUrl: string;
  instanceName: string;
  videoTranscodingService: string;
}

interface UserInfo {
  userFirstName: string;
  userFullName: string;
  userName: string;
  userRole: string;
}

class Session {
  appSessionObj: AppSession;

  promiseApp: Promise<AppSession>;

  async getSessionData(): Promise<AppSession> {
    if (typeof this.promiseApp === 'undefined') {
      this.updateSessionObj();
    }

    return this.promiseApp;
  }

  updateSessionObj(): void {
    this.promiseApp = fetch('/index.php/nghelper/getSession')
      .then((res) => res.json())
      .then(
        (result) => {
          this.appSessionObj = {
            prefLangLocale: result.locale,
            isLoggedIn: !!result.userID,
            dataServer: result.dataserver,
            accountsAPI: result.accountsAPI,
            l10nUnits: { length: result.length_unit, volume: result.volume_unit },
            currencyCode: result.currency_code,
            currencySymbol: result.currency_symbol,
            companyID: result.company_id ? result.company_id : null,
            permissions: makePermissionMap(result.taskPermissions),
            supportEmail: result.support_email,
            customerSupportNumber: result.customer_support_number,
            portalTimezone: result.portalTimezone,
            subdomain: result.subdomain,
            brandedLogoURL: result.brandedLogo ? result.brandedLogo : null,
            userInfo: {
              userFirstName: result.userFirstName,
              userFullName: result.userFullName,
              userName: result.userName,
              userRole: result.role,
            },
            nosletMapCoordinates: {
              lat: result.mapData.map_latitude,
              lon: result.mapData.map_longitude,
            },
            corporateUrl: result.corporate_url,
            instanceName: result.instance,
            videoTranscodingService: result.videoTranscodingService,
          };

          return this.appSessionObj;
        },
        (error) => {
          console.error(error);
        }
      ) as Promise<AppSession>;
  }
}

export const SessionService = new Session();
